import React from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';
import HeaderContainer from '../../components/shared/Header/Header.container';
import colors from '../../config/colors';
import { HomePageProps } from './HomePage.component';
import WebHeader from '../../components/shared/Header/WebHeader.component';
import ClockReport from '../../components/shared/ClockReport/Clock.container';
import PaycheckCard from './SubComponents/PaycheckCard';
import Form101Card from './SubComponents/Form101Card';
import WageSummaryCard from './SubComponents/WageSummaryCard';
import WelcomeCard from './SubComponents/WelcomeCard';
import AttendanceStatsCard from './SubComponents/AttendanceStatsCard';
import MonthlyHoursChart from './SubComponents/MonthlyHoursChart';
import DailyHoursChart from './SubComponents/DailyHoursChart';

const HomePageWeb = ({
	navigation,
	isSummaryOnly,
	isPaycheckBlockShown,
	reportDateYear,
	reportContentData,
	report101warning,
	form101Id,
	form101Status,
	form101StatusCode,
	form101LastUpdate,
	monthlyAttendanceData,
	monthlyHoursData,
	weeklyData,
}: HomePageProps) => {
	return (
		<View style={styles.page}>
			<HeaderContainer
				containerStyle={{ backgroundColor: colors.white }}
				navigation={navigation}
				component={WebHeader}
			/>
			<View
				style={[styles.body, isSummaryOnly && styles.bodycentered]}
				nativeID='homePageWebContainer'
			>
				{!isSummaryOnly && (
					<View style={styles.clockPanel}>
						<ClockReport />
					</View>
				)}
				<ScrollView
					style={
						isSummaryOnly
							? styles.rightPanelNarrow
							: styles.rightPanel
					}
					contentContainerStyle={styles.rightPanelContent}
					showsVerticalScrollIndicator={false}
				>
					{/* All users */}
					<WelcomeCard />
					<View style={styles.topRow}>
						<PaycheckCard reportDateYear={reportDateYear} />
						<Form101Card
							form101Id={form101Id}
							isPaycheckBlockShown={isPaycheckBlockShown}
							report101warning={report101warning}
							form101Status={form101Status}
							form101StatusCode={form101StatusCode}
							form101LastUpdate={form101LastUpdate}
							reportDateYear={reportDateYear}
						/>
					</View>

					{/* Clock module users only */}
					{!isSummaryOnly && (
						<>
							<AttendanceStatsCard
								monthlyAttendanceData={monthlyAttendanceData}
							/>
							<View style={styles.chartsRow}>
								<MonthlyHoursChart
									monthlyHoursData={monthlyHoursData}
								/>
								<DailyHoursChart weeklyData={weeklyData} />
							</View>
						</>
					)}

					{/* All users */}
					<WageSummaryCard
						reportDateYear={reportDateYear}
						reportContentData={reportContentData}
					/>
				</ScrollView>
			</View>
		</View>
	);
};

const styles = StyleSheet.create({
	page: {
		flex: 1,
	},
	body: {
		flex: 1,
		paddingHorizontal: 160,
		paddingVertical: 28,
		flexDirection: 'row',
		gap: 24,
	},
	bodycentered: {
		justifyContent: 'center',
	},
	clockPanel: {
		minWidth: 400,
		zIndex: 1,
		//flexShrink: 0,
	},
	rightPanel: {
		flex: 2,
	},
	rightPanelNarrow: {
		flex: 1,
		maxWidth: 800,
	},
	rightPanelContent: {
		gap: 24,
	},
	topRow: {
		flexDirection: 'row',
		gap: 24,
	},
	chartsRow: {
		flexDirection: 'row',
		gap: 24,
	},
});

export default HomePageWeb;
